// extracted by mini-css-extract-plugin
module.exports = {"container":"IppicaScommesseTypeSwitch_container__DhC1P","button":"IppicaScommesseTypeSwitch_button__m8aX8","active":"IppicaScommesseTypeSwitch_active___SwSy"};